import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import type { ProgressPotentialDiscount } from "@/domains/progress/models/types";
import {
  PROGRESS_POTENTIAL_DISCOUNT_LABEL,
  PROGRESS_THANK_YOU_TITLE,
} from "@/domains/progress/utils/progress-page-copy";
import { Card, Heading } from "@/ui";

const cardLayout = tv({
  base: "flex flex-col gap-2 p-5 sm:p-6",
});

const discountTile = tv({
  base: "flex flex-col gap-1 rounded-card border border-line bg-surface-sunken p-4",
});

export type ProgressThankYouCardProps = ComponentProps<"article"> & {
  message: string;
  potentialDiscount?: ProgressPotentialDiscount | null;
};

export const ProgressThankYouCard = ({
  className,
  message,
  potentialDiscount = null,
  ...props
}: ProgressThankYouCardProps) => {
  return (
    <Card className={cardLayout({ className })} {...props}>
      <Heading level={2}>{PROGRESS_THANK_YOU_TITLE}</Heading>

      <p className="text-content-secondary">{message}</p>

      {potentialDiscount === null ? null : (
        <dl className={discountTile()}>
          <dt className="text-content-secondary">{PROGRESS_POTENTIAL_DISCOUNT_LABEL}</dt>

          <dd className="flex flex-col gap-1">
            <span className="text-3xl font-bold text-content">
              ${potentialDiscount.amountUsd.toLocaleString("en-US")}
            </span>

            <span className="text-sm text-content-secondary">{potentialDiscount.note}</span>
          </dd>
        </dl>
      )}
    </Card>
  );
};
